import Box from '@mui/material/Box';
import { BodyCellRenderResult, Column, RowTypeBase } from '@qre-mailing/smart-table';

const PREVIEW_WORDS = 2;

const lowercaseFirstLetter = (str: string): string => str.charAt(0).toLowerCase() + str.slice(1);

// textContent joins block elements without whitespace
const separateBlocks = (html: string): string => html.replace(/<\/(p|div|li|h[1-6])>|<br\s*\/?>/gi, '$& ');

const htmlToText = (html: string): string =>
  (new DOMParser().parseFromString(separateBlocks(html), 'text/html').body.textContent ?? '')
    .replace(/\s+/g, ' ')
    .trim();

const htmlPreview = (html: string): string => {
  const words = htmlToText(html).split(' ').filter(Boolean);
  if (words.length <= PREVIEW_WORDS) {
    return words.join(' ');
  }
  return `${words
    .slice(0, PREVIEW_WORDS)
    .join(' ')
    .replace(/[\s,.;:!?]+$/, '')}…`;
};

export const htmlColumnRenderer = <RowType extends RowTypeBase>(
  row: RowType,
  column: Column<RowType>
): BodyCellRenderResult => {
  const value = row[(column.fieldKey ?? lowercaseFirstLetter(column.fieldName)) as keyof RowType];
  const html = typeof value === 'string' ? value : '';
  const preview = htmlPreview(html);

  return {
    node: preview,
    value: preview,
    tooltip: (
      <Box
        sx={{
          maxHeight: 400,
          overflowY: 'auto',
          '& p': { my: 0.5 },
          // as in the QB editor, lighter shade for the dark tooltip
          '& .interviewer-note': {
            my: 0.5,
            pl: 1,
            borderLeft: '3px solid',
            borderColor: 'primary.light',
            color: 'primary.light',
            fontStyle: 'italic',
          },
        }}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    ),
  };
};
